(() => {
  const SECTION_SELECTOR = '.custom-guides-whats-inside-v2';

  function initSection(section) {
    if (!section || section.dataset.customGuidesWhatsInsideInitialized === 'true') return;

    section.dataset.customGuidesWhatsInsideInitialized = 'true';

    if (section.classList.contains('custom-guides-whats-inside-v2--animate')) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                section.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.16 }
        );

        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    } else {
      section.classList.add('is-visible');
    }
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
